var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCro1381Beds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 13.4167V3.41675H1.99984V10.0834H7.33317V4.75008H12.6665C13.3998 4.75008 14.0276 5.01119 14.5498 5.53341C15.0721 6.05564 15.3332 6.68341 15.3332 7.41675V13.4167H13.9998V11.4167H1.99984V13.4167H0.666504ZM4.6665 9.41675C4.11095 9.41675 3.63873 9.2223 3.24984 8.83341C2.86095 8.44453 2.6665 7.9723 2.6665 7.41675C2.6665 6.86119 2.86095 6.38897 3.24984 6.00008C3.63873 5.61119 4.11095 5.41675 4.6665 5.41675C5.22206 5.41675 5.69428 5.61119 6.08317 6.00008C6.47206 6.38897 6.6665 6.86119 6.6665 7.41675C6.6665 7.9723 6.47206 8.44453 6.08317 8.83341C5.69428 9.2223 5.22206 9.41675 4.6665 9.41675Z",
    fill: "#6E7983"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCro1381Beds);
export default __webpack_public_path__ + "static/media/cro1381-beds.924f188c.svg";
export { ForwardRef as ReactComponent };